module.exports = __webpack_public_path__ + "assets/images/tri_y.da39f05f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/tri_y.png
// module id = 773
// module chunks = 1